import { render, staticRenderFns } from "./ColorTweaker.vue?vue&type=template&id=6711e4e7&"
import script from "./ColorTweaker.vue?vue&type=script&lang=ts&"
export * from "./ColorTweaker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports